export default {
  azureMedtronic: {
    logoutUrl: 'https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0'
  },
  epicDisney: {
    logoutUrl: 'https://mypremisehealth.com/MyChart/Authentication/Login'
  }
};
